import { FOREST_ROAD, HIGHWAY, HILL_TOWN, HILL_VILLAGE, MARKET, RESIDENTIAL, TOWN, VILLAGE } from './streetscapes';
import type { Route } from './types';

/**
 * DRAFT: the long road up the Akuapem hills and down to Koforidua, one way. Stops and village order are as the owner
 * gave them; distances are game-scale (about 12 km), and the hills are only a backdrop and a change in speed.
 */
export const MADINA_KOFORIDUA: Route = {
  id: 'madina-koforidua',
  name: 'Madina → Koforidua',
  from: 'Madina',
  to: 'Koforidua',
  length: 12000,
  oneWay: true,
  legs: [
    { id: 'madina-adenta', name: 'Madina to Adenta', subtitle: 'Madina Market, Adenta', start: 0, end: 1400, traffic: 1.2, streetscape: MARKET, relief: 0 },
    { id: 'frafraha-oyibi', name: 'Frafraha to Oyibi', subtitle: 'Frafraha, Oyibi, Oyarifa', start: 1400, end: 2800, traffic: 1.0, streetscape: RESIDENTIAL, relief: 0.2, grade: 0.01 },
    { id: 'aburi', name: 'Aburi', subtitle: 'Up into the Akuapem hills', start: 2800, end: 4400, traffic: 0.8, streetscape: FOREST_ROAD, relief: 0.75, grade: 0.05 },
    { id: 'mampong-tutu', name: 'Mampong and Tutu', subtitle: 'On the ridge', start: 4400, end: 5600, traffic: 0.8, streetscape: HILL_VILLAGE, relief: 1, grade: 0.03 },
    { id: 'amanokrom-akropong', name: 'Amanokrom to Akropong', subtitle: 'Along the top of the hills', start: 5600, end: 7000, traffic: 0.9, streetscape: HILL_TOWN, relief: 1, grade: 0 },
    { id: 'mamfe-adawso', name: 'Mamfe to Adawso', subtitle: 'Coming down the hills', start: 7000, end: 8800, traffic: 0.9, streetscape: VILLAGE, relief: 0.7, grade: -0.04 },
    { id: 'mile-50', name: 'Mile 50', subtitle: 'The roadside market', start: 8800, end: 9800, traffic: 1.1, streetscape: VILLAGE, relief: 0.4, grade: -0.03 },
    { id: 'okorase', name: 'Okorase', subtitle: 'Last stretch of farmland', start: 9800, end: 10800, traffic: 1.0, streetscape: HIGHWAY, relief: 0.3, grade: -0.01 },
    { id: 'koforidua', name: 'Koforidua', subtitle: 'Into the town', start: 10800, end: 12000, traffic: 1.2, streetscape: TOWN, relief: 0.3 },
  ],
  stops: [
    { id: 'madina', name: 'Madina', at: 160, crowd: [6, 10] },
    { id: 'adenta', name: 'Adenta', at: 800, crowd: [4, 8] },
    { id: 'frafraha', name: 'Frafraha', at: 1500, crowd: [2, 5] },
    { id: 'oyibi', name: 'Oyibi / Oyarifa', at: 2200, crowd: [2, 5] },
    { id: 'aburi', name: 'Aburi', at: 3100, crowd: [3, 6] },
    { id: 'mampong', name: 'Mampong', at: 4100, crowd: [2, 5] },
    { id: 'tutu', name: 'Tutu', at: 4900, crowd: [2, 4] },
    { id: 'amanokrom', name: 'Amanokrom', at: 5600, crowd: [2, 4] },
    { id: 'akropong', name: 'Akropong', at: 6400, crowd: [3, 6] },
    { id: 'mamfe', name: 'Mamfe', at: 7400, crowd: [2, 5] },
    { id: 'adawso', name: 'Adawso', at: 8400, crowd: [2, 4] },
    { id: 'mile-50', name: 'Mile 50', at: 9300, crowd: [3, 6] },
    { id: 'okrase', name: 'Okrase / Okorase', at: 10200, crowd: [2, 5] },
    { id: 'koforidua', name: 'Koforidua', at: 11760, crowd: [6, 10] },
  ],
  // Signals only in the towns; the villages have none.
  junctions: [
    { id: 'madina-zongo', name: 'Madina Zongo junction', at: 380 },
    { id: 'adenta', name: 'Adenta junction', at: 1140 },
    { id: 'aburi', name: 'Aburi junction', at: 3420 },
    { id: 'akropong', name: 'Akropong junction', at: 6660 },
    { id: 'koforidua', name: 'Koforidua junction', at: 11380 },
  ],
  stations: [
    { id: 'adenta-fuel', name: 'Adenta Fuel', at: 1260 },
    { id: 'hills-oil', name: 'Hilltop Oil', at: 3600 },
    { id: 'ridge-fuel', name: 'Ridge Fuel', at: 6000 },
    { id: 'mamfe-oil', name: 'Mamfe Oil', at: 8280 },
    { id: 'okorase-fuel', name: 'Okorase Fuel', at: 10800 },
  ],
  draft: true,
};
